import { render, staticRenderFns } from "./StatsContent.vue?vue&type=template&id=86ce0d3a"
import script from "./StatsContent.vue?vue&type=script&lang=js"
export * from "./StatsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports